import { StackScreenProps } from "@react-navigation/stack";
import {
  InvoiceArrivalRootParamList,
  ViewInvoiceArrivalRootParamList,
} from "../../../../types";
import { InvoiceArrival } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_INVOICE_ARRIVAL } from "../../utils";
import React from "react";
import { useLazyQuery } from "@apollo/client";
import { PageErrorOccurred } from "../../../../components";
import {
  ActiveInvoiceArrivalContext,
  useInvoiceArrival,
} from "../../utils/active-invoice-arrival";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { ViewInvoiceArrivalScreen } from "../ViewInvoiceArrivalScreen";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { PlaceholderLoadingScreen } from "../../../products/screens/PlaceholderLoadingScreen";
import { ResourcePageSkeleton } from "../../../point-of-sale/screens/ResourcPageSkeleton";

export type ViewInvoiceArrivalRootScreenProps =
  StackScreenProps<InvoiceArrivalRootParamList>;

const ViewInvoiceArrival = ({
  invoiceArrival,
}: ViewInvoiceArrivalRootScreenProps & {
  invoiceArrival: InvoiceArrival;
}) => {
  const Drawer = createStackHeaderNavigator<ViewInvoiceArrivalRootParamList>();
  const context = useInvoiceArrival(invoiceArrival);

  return (
    <ActiveInvoiceArrivalContext.Provider value={context}>
      <Drawer.Navigator
        screenOptions={{
          animationEnabled: true,
          headerLeft: () => <ModalCloseButton type="Back" />,
          title: "",
        }}
      >
        <Drawer.Group>
          <Drawer.Screen
            name="ViewInvoiceArrivalScreen"
            component={ViewInvoiceArrivalScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </ActiveInvoiceArrivalContext.Provider>
  );
};

export const ViewInvoiceArrivalRootScreen = (
  props: ViewInvoiceArrivalRootScreenProps
) => {
  const [invoiceArrival, setInvoiceArrival] = React.useState<
    InvoiceArrival | undefined
  >(undefined);
  const transitionEnded = useHasTransitionEnded(props.navigation);
  const [error, setError] = React.useState<string | undefined>(undefined);

  // ive fucked up the types somewhere. but this is correct code.
  //@ts-ignore
  const id = props.route.params?.invoiceArrivalId;
  const [q] = useLazyQuery(QUERY_INVOICE_ARRIVAL);

  React.useEffect(() => {
    if (id) {
      q({
        variables: {
          id,
        },
      })
        .then((r) => {
          if (!r.data || r.error) {
            setError("Not found");
          }
          setInvoiceArrival(r.data?.invoiceArrival);
        })
        .catch((e) => {
          setError("Not found");
        });
    }
  }, []);

  if (!invoiceArrival && error) {
    return (
      <PageErrorOccurred
        errorMessage={error}
        onRetry={() => {
          props.navigation.reset({
            index: 0,
            routes: [{ name: "InvoiceArrivalsLandingScreen" }],
          });
        }}
      />
    );
  }

  // Wait for transition to end before rendering the screen
  // otherwise the screen animation will be janky
  if (!invoiceArrival || false == transitionEnded) {
    return (
      <PlaceholderLoadingScreen
        navigation={props.navigation}
        content={ResourcePageSkeleton}
      />
    );
  }

  return <ViewInvoiceArrival {...props} invoiceArrival={invoiceArrival} />;
};
